var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasicConfiguration',{attrs:{"text-template":_vm.textTemplate},on:{"update":_vm.updateTextTemplate,"back":_vm.back}})
}
var staticRenderFns = []

export { render, staticRenderFns }